'use client'

import React from 'react'
import { useLocale } from 'next-intl'
import { Link } from '@/i18n/navigation'

import { ButtonLabel } from '@/components/atoms/Typography'
import DropDown from '@/components/atoms/Dropdown'

import styles from './Languages.module.scss'

import { LOCALES } from '@/config/constants'

const locales = LOCALES.map((locale, index) => ({
  shortenedCode: locale,
  order: index,
  locale,
  href: `/`,
}))

const i18nUrls = locales.sort((a, b) => {
  const aFullLocale = locales.find((loc) => loc.shortenedCode === a.locale)
  const bFullLocale = locales.find((loc) => loc.shortenedCode === b.locale)
  return aFullLocale.order < bFullLocale.order ? -1 : 1
})

const Languages = () => {
  const locale = useLocale()
  const hasMultipleLocales = LOCALES.length > 1

  return (
    hasMultipleLocales && (
      <div className={styles.languages}>
        <DropDown
          trigger={locale}
          triggerProps={{
            translate: 'no',
            css: { textTransform: 'uppercase' },
          }}
        >
          {i18nUrls.map((link) => {
            const localeName = link.locale

            return (
              <li key={link.locale}>
                <Link
                  translate='no'
                  href={link.href}
                  locale={link.locale}
                >
                  <ButtonLabel>{localeName.toLocaleUpperCase()}</ButtonLabel>
                </Link>
              </li>
            )
          })}
        </DropDown>
      </div>
    )
  )
}

export default Languages
